import { HttpMethods } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = 'ContentType/';

export const GetContentTypesAPI = ({ channelId = null, ...props } = {}) => {
  // Null channelId is omitted so All Channels stays an unfiltered GET.
  const query =
    channelId !== null && channelId !== undefined
      ? `?channelId=${encodeURIComponent(channelId)}`
      : '';
  const endpoint = `${apiHost}${apiContext}${query}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    ...props,
  });
};

export const GetInternalContentTypesAPI = ({ library = null, ...props } = {}) => {
  const api = 'InternalTypes';
  // Optional library filter (e.g. 'Commercial'); omitted returns all libraries.
  const query = library ? `?library=${encodeURIComponent(library)}` : '';
  const endpoint = `${apiHost}${apiContext}${api}${query}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    ...props,
  });
};
